import React from "react";
import { Segment, Header, Image, List, Container } from "semantic-ui-react";

import DirectMessages from "./DirectMessages";
import SearchUsersComponent from "./SearchUsersComponent";
import Quotes from "./Quotes";
import Breathe from "./Breathe";
import BlockedUsers from "./BlockedUsers";

class ChatMetaPanel extends React.Component {
  state = {
    channel: this.props.currentChannel,
    privateChannel: this.props.isPrivateChannel,
    activeIndex: 0,
  };

  setActiveIndex = (event, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  formatCount = (num) =>
    num > 1 || num === 0 ? `${num} comments` : `${num} comment`;

  displayTopPosters = (posts) =>
    Object.entries(posts)
      .sort((a, b) => b[1] - a[1])
      .map(([key, val], i) => (
        <List.Item key={i}>
          <Image avatar src={val.avatar} />
          <List.Content>
            <List.Header as="a">{key}</List.Header>
            <List.Description>{this.formatCount(val.count)}</List.Description>
          </List.Content>
        </List.Item>
      ))
      .slice(0, 2);

  render() {
    // const { activeIndex, privateChannel, channel } = this.state;
    // const { userPosts } = this.props;

    // if (privateChannel) return null;

    return (
      <React.Fragment>
        <Segment style={{ overflow: "auto", maxHeight: 200 }}>
          <DirectMessages
            currentUser={this.props.currentUser}
            currentChannel={this.props.currentChannel}
          />
        </Segment>

        <Segment style={{ overflow: "auto", maxHeight: 250 }}>
          <SearchUsersComponent currentUser={this.props.currentUser} />
        </Segment>

        <Segment style={{ overflow: "auto", maxHeight: 200 }}>
          <BlockedUsers currentUser={this.props.currentUser} />
        </Segment>
      </React.Fragment>
    );
  }
}

export default ChatMetaPanel;



// WEBPACK FOOTER //
// ./src/components/MetaPanel/ChatMetaPanel.js